// PrintingPage.jsx
import React, { useState } from "react";
import CompanyTabs from "../Common/CompanyTabs";
import PrintingSheetsPanel from "./PrintingSheetsPanel";

export default function PrintingPage() {
  const [activeCompany, setActiveCompany] = useState(null);
  const [activeSheetsTab, setActiveSheetsTab] = useState("current"); // current | completed

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between">
        <h3 className="mb-3 ms-3">Листы на печать</h3>
      </div>

      <CompanyTabs 
        activeCompany={activeCompany} 
        setActiveCompany={setActiveCompany} 
        countEndpoint = "/printing/sheets/count"
      />

      {activeCompany && (
        <PrintingSheetsPanel
          activeTab={activeSheetsTab}
          setActiveTab={setActiveSheetsTab}
          companyId={activeCompany}
        />
      )}
    </div>
  );
}